import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

interface DriverCreatingWizardScreenProps {
  isUpdate?: boolean;
}

export const DriverCreatingWizardScreen = ({ isUpdate }: DriverCreatingWizardScreenProps) => {
  const intl = useIntl();

  const text = (() => {
    if (isUpdate) {
      return intl.formatMessage({
        id: 'predict.non_financial_drivers.updating_driver',
        defaultMessage: 'Updating driver...'
      });
    }
    return intl.formatMessage({
      id: 'predict.non_financial_drivers.creating_driver',
      defaultMessage: 'Creating driver...'
    });
  })();

  return <LoadingWizardScreen text={text} />;
};
